export default __webpack_public_path__ + "static/media/menu-tile-identity.22201958.png";